
















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { VPopover } from 'v-tooltip';

@Component({
  components: {
    VPopover,
  },
})
export default class StConfirmButton extends Vue {
  @Prop() tooltipText!: string;
  @Prop() confirmTooltipText!: string;
  @Prop() loading!: boolean;
  @Prop() tooltipOnBody!: boolean;
  @Prop() small!: boolean;

  timeout: any;
  awaitsConfirmation: boolean = false;

  startDelete() {
    this.awaitsConfirmation = true;
    this.$emit('startConfirm');
    this.timeout = setTimeout(() => {
      this.awaitsConfirmation = false;
      this.$emit('endConfirm');
      clearTimeout(this.timeout);
    }, 6000);
  }

  cancelDelete() {
    if (this.timeout) {
      this.awaitsConfirmation = false;
      this.$emit('endConfirm');
      clearTimeout(this.timeout);
    }
  }

  beforeDestroy(){
    this.cancelDelete();
  }

  @Emit('confirm')
  confirm() {
    return;
  }

  @Emit('doubleConfirm')
  doubleConfirm() {
    return;
  }
}
